import { SelectBaseProps } from 'govwell-ui/components/Select/types'

import { DistanceUnit } from '../../../../types/graphql'
import { SelectFieldProps } from '../../../utils/forms'
import DistanceUnitSelect from '../../Selects/DistanceUnitSelect'

type Props<TKey extends string> = Omit<SelectBaseProps<DistanceUnit>, 'getOptionKey' | 'options'> &
  SelectFieldProps<DistanceUnit, TKey>

const DistanceUnitSelectField = <TKey extends string>({
  field,
  filterOption,
  isDisabled,
  isMultiSelect,
  isRequired,
  label,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  const commonProps = {
    errorMessage,
    filterOption,
    isDisabled,
    isInvalid: !!errorMessage,
    isRequired: isRequired,
    onBlur: field.handleBlur,
    label: label,
  }

  if (isMultiSelect) {
    return (
      <DistanceUnitSelect
        isMultiSelect
        onValueChange={field.setValue}
        value={field.state.value}
        {...commonProps}
      />
    )
  }
  return (
    <DistanceUnitSelect
      isMultiSelect={false}
      onValueChange={field.setValue}
      value={field.state.value}
      {...commonProps}
    />
  )
}

export default DistanceUnitSelectField
